import React, {useContext, useRef} from "react";
import {Button, Form, Input, Space, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import Clipboard from "react-clipboard.js";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// core
import {InterceptorContext, LayoutContext, ModalContext} from "../../../core/Contexts";
// hooks
import useFormHandler from "../../../core/hooks/useFormHandler";
// components
import Error from "../../modal/error";
import Success from "../../modal/success";

export default React.memo(
    observer(function SimForm({phone, message}: IProps) {
        const context = useContext(InterceptorContext);
        const contextLayout = useContext(LayoutContext);
        const contextModal = useContext(ModalContext);
        const ref = useRef(null);
        const {t} = useTranslation();
        const [form] = Form.useForm();
        const formInstance = useFormHandler(form);

        const onCan = () => {
            contextModal?.setVisible(false);
            context?.setErrors(undefined);
            form.resetFields();
            contextModal?.setCssClass("");

            if (context?.setLoading) {
                context?.setLoading(true);
            }
            window.location.reload();
        };

        const onFinish = async ({phone}: {phone: string}) => {
            try {
                (ref.current as any).querySelector(".copy").click();
                contextModal?.setCssClass("");
                contextModal?.setChildren(
                    <Success
                        title={
                            <Typography as="span" color="#fff">
                                {t("Номер скопирован ")}
                                <br />
                                {t("в буфер обмена")}
                            </Typography>
                        }
                    />
                );
            } catch (e: any) {
                contextModal?.setChildren(<Error />);
            } finally {
                contextModal?.setOnCancel(() => onCan);
            }
        };

        return (
            <div ref={ref}>
                <Clipboard
                    className="copy"
                    component="span"
                    data-clipboard-text={message}
                ></Clipboard>

                <Typography as="div" className="bl-sim-form">
                    <Form
                        form={formInstance}
                        layout="horizontal"
                        name="sim"
                        onFinish={onFinish}
                        autoComplete="off"
                        initialValues={{
                            phone
                        }}
                    >
                        <Form.Item noStyle name="phone" hidden={true}>
                            <Input />
                        </Form.Item>
                        <Space
                            size={_.gte(contextLayout?.width ?? 0, 768) ? 16 : 8}
                            direction={
                                _.gte(contextLayout?.width ?? 0, 768) ? "horizontal" : "vertical"
                            }
                        >
                            <Typography
                                as="div"
                                className="text-center cancel"
                                size={14}
                                color="#000"
                            >
                                <Button type="text" onClick={onCan} className="cancel-btn">
                                    {t("Закрыть")}
                                </Button>
                            </Typography>
                            <Form.Item shouldUpdate>
                                {() => {
                                    return (
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            loading={context?.loadingBtn}
                                            className="copy-btn"
                                        >
                                            {t("Скопировать")}
                                        </Button>
                                    );
                                }}
                            </Form.Item>
                        </Space>
                    </Form>
                </Typography>
            </div>
        );
    })
);

interface IProps {
    phone: number;
    message: string | undefined;
}
